import React from "react";

import {
  SingleTopicStories,
  SingleTopicStoriesLoading,
} from "../SingleTopicStories";
import { UserTopicPanelProps, PanelTypes } from "../types";

const NUMBER_OF_STORIES_PER_TOPIC = 5;

export const UserTopicPanel = ({ type, props }: UserTopicPanelProps) => {
  switch (type) {
    case PanelTypes.LoadingTopicCard:
      return (
        <SingleTopicStoriesLoading
          numberOfRows={NUMBER_OF_STORIES_PER_TOPIC}
          length={1}
        />
      );

    case PanelTypes.TopicCard:
      return (
        <SingleTopicStories
          rootRef={props.rootRef}
          topic={props.topic}
          stories={props.stories}
          followTopicCallback={props.followTopicCallback}
          numberOfRows={NUMBER_OF_STORIES_PER_TOPIC}
          isSignedIn={props.isSignedIn}
        />
      );
  }

  return null;
};
